import React, { useEffect, useRef, useState } from "react";
// @ts-ignore
import DatePicker from "react-mobile-datepicker";
import { dateFormat } from "../../units";

const classnames = require('classnames');

interface DatePickerBoxProps {
    value?: Date,
    label?: string,
    onChange?: (time: string) => void,
    DateConfig?: any,
    [propName: string]: any
}

function tfTime(n: any) {
    if (!n) {
        return false
    }
    if (typeof n === 'string') {
        return new Date(n.replace(/-/g, '/'))
    } else if (typeof n === 'number') {
        return new Date(n)
    } else if (n instanceof Date) {
        return n
    } else {
        return new Date()
    }
}


const DatePickerBox: React.FC<DatePickerBoxProps> = (props) => {
    // console.log(props.value)
    const [show, setShow] = useState(false)
    const [time, setTime] = useState(props.value)
    const errors = props['data-__field'] && props['data-__field'].errors;
    const isInit = useRef(false)

    const onSelect = (time: Date) => {
        setTime(time)
        setShow(false)
        if (props.onChange) {
            props.onChange(dateFormat(time))
        }
    }

    useEffect(() => {
        if (!isInit.current) {
            setTime(tfTime(props.value) || undefined)
        }
    }, [props.value])

    const DateConfig = props.DateConfig || {
        'year': {
            format: 'YYYY',
            caption: '年',
            step: 1,
        },
        'month': {
            format: 'M',
            caption: '月',
            step: 1,
        },
        'date': {
            format: 'D',
            caption: '日',
            step: 1,
        }
    }


    const close = () => {
        setShow(false)
    }

    const open = () => {
        isInit.current = true
        setShow(true)
    }

    const openInit = () => {
        setTime(new Date())
        open()
    }

    // console.log(time)

    return <div className='date-box'>
        <div className={classnames("flex", { 'hasLabel': props.label })}>
            {
                props.label && <p className="label">{props.label}</p>
            }
            {
                time ? <p className="time" style={{ letterSpacing: '1px' }} onClick={open}>{dateFormat(time, '-', Object.keys(DateConfig))}</p>
                    : <p className="time placeholder" style={{ letterSpacing: '1px' }} onClick={openInit}>请选择时间</p>
            }
            {
                errors && <p className='error'>{errors[0].message}</p>
            }
        </div>




        <div className="date-cover">
            <div className="date-picker">
                {
                    time && <DatePicker
                        // showCaption
                        dateConfig={DateConfig}
                        showHeader={false}
                        theme={'ios'}
                        value={tfTime(time)}
                        isOpen={show}
                        min={new Date(1930, 0, 1,)}
                        onSelect={onSelect}
                        onCancel={close}
                    />
                }

            </div>
        </div>
    </div>
}

export default DatePickerBox
